_ = require("lodash")

class ScoreCardInfoCtrl
  constructor: (@$scope, @ScoreCardParser) ->
    @is18Holes = _.size(@$scope.$parent.roundInfo.holes) is 18
    @roundType = @$scope.$parent.roundInfo.round_type
    @hasExtra = @$scope.$parent.roundInfo.has_extra
    @course = @$scope.$parent.roundInfo.course
    @course_extra = @$scope.$parent.roundInfo.course
    @tee = @$scope.$parent.roundInfo.tee
    @tee_extra = @$scope.$parent.roundInfo.tee_extra

    @inScoreCardInfo = @ScoreCardParser.parseInViewModel @$scope.$parent.roundInfo if @is18Holes
    @outScoreCardInfo = @ScoreCardParser.parseOutViewModel @$scope.$parent.roundInfo
    @extraScoreCardInfo = @ScoreCardParser.parseScoreCardExtraBoard @$scope.$parent.roundInfo if @hasExtra
    @totalScoreCardInfo = @ScoreCardParser.parseTotalViewModel @$scope.$parent.roundInfo, @is18Holes

    @hasPlayerHdcp = @$scope.$parent.roundInfo.players[0].player_hdcp isnt null

ScoreCardInfoCtrl.$inject = [
  '$scope'
  'ScoreCardParser'
]

module.exports = ScoreCardInfoCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/round-detail/score-card-info/score-card-info-controller.coffee